module.exports = __webpack_public_path__ + "static/media/slim-down.8292a2f3.svg";